import { render, staticRenderFns } from "./CreditorInfo.vue?vue&type=template&id=2cbbfef0&scoped=true"
import script from "./CreditorInfo.vue?vue&type=script&lang=ts"
export * from "./CreditorInfo.vue?vue&type=script&lang=ts"
import style0 from "./CreditorInfo.vue?vue&type=style&index=0&id=2cbbfef0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbfef0",
  null
  
)

export default component.exports